import MenuItems from 'components/common/MenuItem/MenuItem';
import { ReactComponent as SuitcaseIcon } from 'assets/icons/suitcase.svg';
import { ReactComponent as EducationIcon } from 'assets/icons/education.svg';
import { ReactComponent as GlobeIcon } from 'assets/icons/globe.svg';
import { ReactComponent as StarIcon } from 'assets/icons/star.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/profile-box.svg';
import { ReactComponent as GoalIcon } from 'assets/icons/goal.svg';
import { ReactComponent as FriendsIcon } from 'assets/icons/friends.svg';
import { ReactComponent as SafeBox } from 'assets/icons/safe-box.svg';
import * as S from './Questionnaire.styled';
import { Box } from '@mui/material';
import BaseInput from 'components/common/BaseInput';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'contexts/ProtectedRoute';
import ROLES from 'assets/userRoles.json';

const navItems = [
    {
        id: '1',
        icon: ProfileIcon,
        title: 'Personal Info',
        path: 'general',
    },
    {
        id: '2',
        icon: GoalIcon,
        title: 'Purpose',
        path: 'purpose',
    },
    {
        id: '3',
        icon: SuitcaseIcon,
        title: 'Work Experience',
        path: 'work-experience',
    },
    {
        id: '4',
        icon: EducationIcon,
        title: 'Education',
        path: 'education',
    },
    {
        id: '5',
        icon: GlobeIcon,
        title: 'Language Proficiency',
        path: 'language-proficiency',
    },
    {
        id: '6',
        icon: StarIcon,
        title: 'Job Offer',
        path: 'job-offer',
    },
    {
        id: '7',
        icon: FriendsIcon,
        title: 'Relatives Abroad',
        path: 'relative-abroad',
    },
    {
        id: '8',
        icon: SafeBox,
        title: 'Business Experience',
        path: 'business-experience',
    },
    {
        id: '9',
        icon: SafeBox,
        title: 'Academic Interest',
        path: 'academic-info',
    },
];

const providerNavItem = [
    {
        id: '1',
        icon: ProfileIcon,
        title: 'Personal Info',
        path: '',
    },
    {
        id: '2',
        icon: GoalIcon,
        title: 'License',
        path: 'license',
    },
    {
        id: '3',
        icon: SuitcaseIcon,
        title: 'Company',
        path: 'company',
    },
    {
        id: '4',
        icon: ProfileIcon,
        title: 'Additional Consultants',
        path: 'additional-consultants',
    },
    {
        id: '5',
        icon: GoalIcon,
        title: 'Bank Account Details',
        path: 'bank-account-details',
    },
    {
        id: '6',
        icon: SuitcaseIcon,
        title: 'Terms of Use',
        path: 'terms-of-use',
    },
];

const mystyle = {
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
};

export default function QuestionnaireSideBarItem() {
    const params = useParams();
    const candidate_id = Number(params.id);

    const [name, setName] = useState('');

    const { role } = useAuth();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    };

    const itemList =
        (ROLES.admin === role || ROLES.superAdmin === role || ROLES.superSuperAdmin === role) &&
        !candidate_id
            ? providerNavItem
            : navItems;

    return (
        <>
            <S.HideXs>
                {itemList.map((item, index) => (
                    <S.SbItemContainer>
                        <S.SbItem>
                            <MenuItems
                                key={index}
                                {...item}
                                iconSize={'20px'}
                                // props={props?.id}
                                gap="20px"
                                styleText={mystyle}
                            />
                        </S.SbItem>
                    </S.SbItemContainer>
                ))}
            </S.HideXs>
            <S.HideLg>
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { width: '100%' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <div>
                        <BaseInput
                            id=""
                            select
                            label="Select Info"
                            value={name}
                            onChange={handleChange}
                        >
                            {itemList.map((item) => (
                                <S.MenuItem key={item.id} value={item.id}>
                                    <S.NavLink to={item.path}>
                                        <S.NavLinkSpan>
                                            <item.icon
                                                style={{ fill: 'inherit', marginRight: '1.25rem' }}
                                            />

                                            <S.Text>{item.title}</S.Text>
                                        </S.NavLinkSpan>
                                    </S.NavLink>
                                </S.MenuItem>
                            ))}
                        </BaseInput>
                    </div>
                </Box>
            </S.HideLg>
        </>
    );
}
